import React from 'react'
import Table, { TableRow } from '../../../../../../common/components/molecule/Table/Table';
import { UserRole, userRolesTraductor } from '../../../../types/user.types';
import {  AxiosError } from 'axios';

export interface UserItem {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    userRole?:UserRole;
    onClick?: () => void;
    organizationNameRender: () => JSX.Element;
    userStatusRender?: () => JSX.Element;
    userRoleRender?: () => JSX.Element;



} 

export interface UserListViewProps {
    content?: UserItem[];
    isLoading?: boolean;
    isError?: boolean;
    error?: AxiosError
    nbFound?: number;
}


export default function UserListView({ content, isError, isLoading, error, nbFound  }: UserListViewProps) {

    const contentFormated: TableRow[]  = content?.map((item) => {
        return {
            id: item.id,
            onRowClick: () => item.onClick && item.onClick(),
            data: [
                item.firstName,
                item.lastName,
                item.email,
                item.userRole ? userRolesTraductor(item.userRole) : "",
       
                () => item.organizationNameRender(),
                item.userStatusRender,
            ],
        };
    }) || [];
    
  return (
        <Table
        headerTitle={["Prénom",  "Nom", "Email", "Rôle", "Organisation", "Statut"]}
        bodyData={contentFormated}
        emptyMessage="Aucun utilisateur trouvé"
        NbFoundViewProps={{
            nbFound: nbFound,
            itemName: { single: "utilisateur trouvé", plurial: "utilisateurs trouvés" },

        }}
      />
  )
}
